export const WA_URL = `https://wa.me/60172726977?text=${encodeURIComponent("Hi! I need a towing at (location)")}`;

export const CONTENT = {
  en: {
    topbar_hotline: "24/7 Emergency Hotline: 017-272 6977",
    nav: { about: "About", services: "Services", fleet: "Fleet", partners: "Partners", contact: "Contact" },
    login: "Login",
    hero: {
      overline: "Established Nov 2025 · Reg. No. 202503325512 (KT0603397-W)",
      title: "PSS TOWING AUTO ASSIST",
      subtitle: "Malaysia's roadside assistance and vehicle towing specialist — affordable, professional, and reliable, 24 hours a day, 7 days a week.",
      whatsapp: "Chat Now on WhatsApp",
      portal: "Staff Portal",
      chips: ["24/7/365 Hotline", "Nationwide Coverage", "DDC Certified Drivers"],
    },
    about: {
      overline: "About Us",
      heading: "Who We Are",
      intro: "We deliver affordable, professional, and reliable services to individuals, corporate clients, insurance providers, workshops, and fleet operators.",
      vision_title: "Our Vision",
      vision: "To be Malaysia's most trusted and reliable automotive recovery partner, setting the industry benchmark in rapid response, damage-free transport, and premium roadside assistance.",
      mission_title: "Our Mission",
      mission: "To deliver peace of mind to every motorist through a modern, specialized fleet and dedicated professionals, ensuring swift, safe, and efficient solutions.",
      leadership_title: "Our Leadership",
      leadership: "Led by Encik Khairul Anuar, an experienced professional in vehicle recovery and operational management, committed to safety, efficiency, and continuous improvement.",
      leadership_role: "Founder & Operations Director",
    },
    services: {
      overline: "Our Services",
      heading: "Seven Core Services, One Call Away",
      items: [
        { name: "Flatbed Towing", desc: "Premium damage-free flatbed transport for all vehicle types." },
        { name: "Hook Towing", desc: "Fast and secure hook towing for breakdowns and accidents." },
        { name: "4x4 & MC Recovery", desc: "Specialized recovery for 4x4s and motorcycles, on or off-road." },
        { name: "Fuel Savior", desc: "Emergency fuel delivery when your tank runs empty." },
        { name: "Tyre Changer", desc: "On-the-spot tyre replacement and repair." },
        { name: "Lockout Service", desc: "Quick, damage-free vehicle unlocking." },
        { name: "Jumper & Battery Service", desc: "Jump-starts and on-site battery replacement." },
      ],
    },
    fleet: {
      overline: "Fleet & Capabilities",
      heading: "A Specialized Fleet, Ready Around the Clock",
      vehicles: [
        { name: "Ford Ranger 2.0 XL AT", role: "Rapid Response" },
        { name: "Isuzu Elf N-Series NLR", role: "Hook Towing" },
        { name: "Isuzu Elf N-Series NMR", role: "Premium Flatbed Transport" },
      ],
      ops: [
        { title: "24/7/365 Emergency Hotline", desc: "Round-the-clock dispatch, every day of the year." },
        { title: "Smart GPS Dispatch", desc: "Intelligent routing that minimizes your wait time." },
        { title: "Nationwide Coverage", desc: "Including interstate transport across Malaysia." },
        { title: "DDC Certified Drivers", desc: "Every driver is Defensive Driving Course certified." },
      ],
      compat_heading: "Manufacturer Compatibility",
      compat_note: "Guaranteed damage-free recovery for:",
      compat: [
        { group: "National", brands: ["Perodua", "Proton"] },
        { group: "Japanese", brands: ["Toyota", "Honda", "Nissan", "Mitsubishi", "Mazda"] },
        { group: "Continental & Luxury", brands: ["Mercedes-Benz", "BMW", "Audi", "Volkswagen"] },
        { group: "Emerging & EV", brands: ["Chery", "BYD", "Jaecoo", "Hyundai", "Kia"] },
      ],
    },
    partners: {
      overline: "Partners & Compliance",
      heading: "Exclusive Partners",
      list: [
        { name: "Arif AutoRepair Sdn Bhd", desc: "Exclusive mechanical repairs partner." },
        { name: "CarFix My", desc: "Digital roadside assistance network partner." },
      ],
      compliance_heading: "Our Compliance Guarantee",
      compliance: [
        "Zero-damage recovery, guaranteed",
        "Strict adherence to factory standards",
        "Rapid workshop drop-offs",
      ],
    },
    contact: {
      overline: "Contact",
      heading: "Get In Touch",
      hq_title: "Headquarters — Melaka",
      hq: "53-1, Jalan MH 1, Taman Muzaffar Heights, 75450 Ayer Keroh, Melaka",
      kl_title: "KL Branch",
      kl: "6-5-2, Diamond Square Block B, Jalan Gombak, WP Kuala Lumpur",
      phone_title: "Phone & Email",
      phone: "017-272 6977",
      email: "contactus@psstowing.com",
      bank_title: "Banking Details",
      form_title: "Request a Tow / Enquiry",
      form_date: "Date", form_time: "Time",
      form_from: "From (Pickup Location)", form_to: "To (Destination)",
      form_phone: "Contact Number", form_email: "Email (Optional)",
      form_submit: "Send Request",
      form_success: "Request sent! Our team will contact you shortly.",
    },
    footer: {
      tagline: "Malaysian roadside assistance & vehicle towing, established November 2025.",
      rights: "All rights reserved.",
      reg: "Reg. No. 202503325512 (KT0603397-W)",
    },
    fab_label: "Chat Now",
  },
  bm: {
    topbar_hotline: "Talian Kecemasan 24/7: 017-272 6977",
    nav: { about: "Tentang", services: "Perkhidmatan", fleet: "Armada", partners: "Rakan Kongsi", contact: "Hubungi" },
    login: "Log Masuk",
    hero: {
      overline: "Ditubuhkan Nov 2025 · No. Pendaftaran 202503325512 (KT0603397-W)",
      title: "PSS TOWING AUTO ASSIST",
      subtitle: "Pakar bantuan tepi jalan dan tundaan kenderaan Malaysia — berpatutan, profesional dan dipercayai, 24 jam sehari, 7 hari seminggu.",
      whatsapp: "Chat Sekarang di WhatsApp",
      portal: "Portal Staf",
      chips: ["Talian 24/7/365", "Liputan Seluruh Negara", "Pemandu Bertauliah DDC"],
    },
    about: {
      overline: "Tentang Kami",
      heading: "Siapa Kami",
      intro: "Kami menyediakan perkhidmatan yang berpatutan, profesional dan dipercayai kepada individu, pelanggan korporat, syarikat insurans, bengkel dan pengendali armada.",
      vision_title: "Visi Kami",
      vision: "Untuk menjadi rakan pemulihan automotif paling dipercayai dan boleh diharap di Malaysia, menerajui penanda aras industri dalam tindak balas pantas, pengangkutan tanpa kerosakan dan bantuan tepi jalan premium.",
      mission_title: "Misi Kami",
      mission: "Untuk memberikan ketenangan fikiran kepada setiap pemandu melalui armada moden yang khusus dan tenaga profesional yang berdedikasi, memastikan penyelesaian yang pantas, selamat dan cekap.",
      leadership_title: "Kepimpinan Kami",
      leadership: "Diterajui oleh Encik Khairul Anuar, seorang profesional berpengalaman dalam pemulihan kenderaan dan pengurusan operasi, yang komited terhadap keselamatan, kecekapan dan penambahbaikan berterusan.",
      leadership_role: "Pengasas & Pengarah Operasi",
    },
    services: {
      overline: "Perkhidmatan Kami",
      heading: "Tujuh Perkhidmatan Utama, Hanya Satu Panggilan",
      items: [
        { name: "Tunda Flatbed", desc: "Pengangkutan flatbed premium tanpa kerosakan untuk semua jenis kenderaan." },
        { name: "Tunda Cangkuk", desc: "Tunda cangkuk yang pantas dan selamat untuk kerosakan dan kemalangan." },
        { name: "Pemulihan 4x4 & MC", desc: "Pemulihan khusus untuk kenderaan 4x4 dan motosikal, di jalan raya atau luar jalan." },
        { name: "Fuel Savior", desc: "Penghantaran minyak kecemasan apabila tangki anda kosong." },
        { name: "Tukar Tayar", desc: "Penukaran dan pembaikan tayar serta-merta di lokasi." },
        { name: "Perkhidmatan Lockout", desc: "Pembukaan kenderaan terkunci dengan pantas dan tanpa kerosakan." },
        { name: "Jumper & Servis Bateri", desc: "Jump-start dan penggantian bateri di lokasi." },
      ],
    },
    fleet: {
      overline: "Armada & Keupayaan",
      heading: "Armada Khusus, Sedia Sepanjang Masa",
      vehicles: [
        { name: "Ford Ranger 2.0 XL AT", role: "Tindak Balas Pantas" },
        { name: "Isuzu Elf N-Series NLR", role: "Tunda Cangkuk" },
        { name: "Isuzu Elf N-Series NMR", role: "Pengangkutan Flatbed Premium" },
      ],
      ops: [
        { title: "Talian Kecemasan 24/7/365", desc: "Penghantaran sepanjang masa, setiap hari sepanjang tahun." },
        { title: "Penghantaran GPS Pintar", desc: "Laluan pintar yang meminimumkan masa menunggu anda." },
        { title: "Liputan Seluruh Negara", desc: "Termasuk pengangkutan antara negeri di seluruh Malaysia." },
        { title: "Pemandu Bertauliah DDC", desc: "Setiap pemandu bertauliah Kursus Pemanduan Defensif." },
      ],
      compat_heading: "Keserasian Pengeluar",
      compat_note: "Pemulihan tanpa kerosakan dijamin untuk:",
      compat: [
        { group: "Nasional", brands: ["Perodua", "Proton"] },
        { group: "Jepun", brands: ["Toyota", "Honda", "Nissan", "Mitsubishi", "Mazda"] },
        { group: "Benua & Mewah", brands: ["Mercedes-Benz", "BMW", "Audi", "Volkswagen"] },
        { group: "Baharu & EV", brands: ["Chery", "BYD", "Jaecoo", "Hyundai", "Kia"] },
      ],
    },
    partners: {
      overline: "Rakan Kongsi & Pematuhan",
      heading: "Rakan Kongsi Eksklusif",
      list: [
        { name: "Arif AutoRepair Sdn Bhd", desc: "Rakan kongsi eksklusif pembaikan mekanikal." },
        { name: "CarFix My", desc: "Rakan kongsi rangkaian bantuan tepi jalan digital." },
      ],
      compliance_heading: "Jaminan Pematuhan Kami",
      compliance: [
        "Pemulihan tanpa kerosakan, dijamin",
        "Pematuhan ketat kepada piawaian kilang",
        "Penghantaran pantas ke bengkel",
      ],
    },
    contact: {
      overline: "Hubungi Kami",
      heading: "Hubungi Kami",
      hq_title: "Ibu Pejabat — Melaka",
      hq: "53-1, Jalan MH 1, Taman Muzaffar Heights, 75450 Ayer Keroh, Melaka",
      kl_title: "Cawangan KL",
      kl: "6-5-2, Diamond Square Block B, Jalan Gombak, WP Kuala Lumpur",
      phone_title: "Telefon & Emel",
      phone: "017-272 6977",
      email: "contactus@psstowing.com",
      bank_title: "Maklumat Perbankan",
      form_title: "Mohon Tundaan / Pertanyaan",
      form_date: "Tarikh", form_time: "Masa",
      form_from: "Dari (Lokasi Ambil)", form_to: "Ke (Destinasi)",
      form_phone: "Nombor Telefon", form_email: "Emel (Pilihan)",
      form_submit: "Hantar Permohonan",
      form_success: "Permohonan dihantar! Pasukan kami akan menghubungi anda sebentar lagi.",
    },
    footer: {
      tagline: "Bantuan tepi jalan & tundaan kenderaan Malaysia, ditubuhkan November 2025.",
      rights: "Hak cipta terpelihara.",
      reg: "No. Pendaftaran 202503325512 (KT0603397-W)",
    },
    fab_label: "Chat Sekarang",
  },
};
